var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 152,
    viewBox: "0 0 185 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.745432 0.797912L98.181 0.797916L184.878 69.0445L184.878 151.295L0.745432 0.797912Z",
    fill: "#FF7841"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvTag);
export default __webpack_public_path__ + "static/media/envTag.5795d07fbfb746fca68c343aff5d76ba.svg";
export { ForwardRef as ReactComponent };